













import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  name: 'Demo1'
})
export default class Demo1 extends Vue {
  public time1 = new Date().getTime() - 60 * 12 * 1000;
  public time2 = new Date().getTime() - 60 * 65 * 1000;
  public time3 = new Date().getTime() - 60 * 60 * 1000 * 24 * 365;
}
